import { AutocompleteBaidu } from './ac-baidu';
import { AutocompleteGoogle } from './ac-google';
import { AutocompleteWoosmap } from './ac-woosmap';
import { getConfiguration } from './ac-configuration';

/**
 *  Generic AutocompleteFactory
 *  Based on configuration, will return the country-specific autocomplete
 */
export const AutocompleteFactory = (container, callbackInit) => {
  // Get country-specific config
  const config = getConfiguration();

  const cookieValue = (document.cookie || '').split(';').find((str) => str.indexOf('ac-provider') > -1);

  if (cookieValue) config.type = cookieValue.split('=')[1];

  if (config.type === 'WOOSMAP')
    return new AutocompleteWoosmap(container, callbackInit);

  if (config.type === 'GOOGLE')
    return new AutocompleteGoogle(container, callbackInit);

  if (config.type === 'BAIDU')
    return new AutocompleteBaidu(container, callbackInit);

  return new AutocompleteGoogle(container, callbackInit);
};

/**
 *  For DEBUG purpose, you can expose specific country-autocompletes
 *  you can implement them without needing the AutocompleteWrapper
 *  (using this : don't forget the 'new' when instanciating the Autocomplete* !)
 */
// export { AutocompleteBaidu, AutocompleteGoogle };



// WEBPACK FOOTER //
// ./src/commons/component/autocomplete/index.js